import React from 'react';

import AlertBanner from './AlertBanner';

const COVID_VACCINE_LANDING_PAGE_URL =
    'https://www.zocdoc.com/vaccine-covid-19/';

const CoronaVirusAlertBanner = ({
    message = 'Track need-to-know info on the COVID vaccine.',
    linktext = 'Get updates',
    url = COVID_VACCINE_LANDING_PAGE_URL,
    onClick,
}) => (
    <AlertBanner
        message={message}
        linktext={linktext}
        url={url}
        onClick={onClick}
    />
);

export default CoronaVirusAlertBanner;
